<template>
	<div id="footer">
		<div class="container">
			<div class="footer-1">
				<dl>
					<dd v-for="item in linkList">
						<a :href="item.url" target="_blank" class="imgbox_a">
							<img :src="icoURL+'storage/'+item.image" alt="">
						</a>
					</dd>
				</dl>
				<div class="clear"></div>
			</div>
			<div class="footer-2">
				服务热线：{{this.settingObj.tel}} &nbsp 地址：{{this.settingObj.address}} 邮编：{{this.settingObj.zip}} 投稿邮箱：{{this.settingObj.email}} 
				版权所有：{{this.settingObj.copyright}} {{this.settingObj.recordcode}} <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">{{this.settingObj.icp}}</a> <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=61010402000753" ><img src="/images/gongan.png" style="margin:-3px 5px 0 15px"/>陕公网安备 61010402000753号</a>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	  name: 'foot',
		data(){
			return{
				linkList:[],
				setting:[],
				settingObj:{
					tel:'',
					address:'',
					zip:'',
					email:'',
					copyright:'',
					recordcode:'',
					icp:''
					
				},
				key:''
			}
		},
		methods:{
			//请求底部友情链接
			res_link(){
				this.axios.get('/api/link?category_id=33')
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							console.log('response1',response)
							this.linkList = response.data.reslut;
								// this.titleName = response.data.reslut.name;
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			res_siteInfo(){
				this.axios.get('/api/setting')
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
								this.setting = response.data.reslut;
								this.setting.forEach(item=>{
									if(item.key == "default.tel"){
										this.settingObj.tel = item.value;
									}else if(item.key == "default.address"){
										this.settingObj.address = item.value;
									}else if(item.key == "default.zip"){
										this.settingObj.zip = item.value;
									}else if(item.key == "default.email"){
										this.settingObj.email = item.value;
									}else if(item.key == "default.copyright"){
										this.settingObj.copyright = item.value;
									}else if(item.key == "default.recordcode"){
										this.settingObj.recordcode = item.value;
									}else if(item.key == "default.icp"){
										this.settingObj.icp = item.value;
									}
								})
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			}
		},
		created() {
			this.res_link();
			this.res_siteInfo();
		}
	}
</script>

<style>
</style>